import { MediaType } from '@/constants/constants'
import { IFormFieldType } from '@admin/widgets/create-widget'

const TestimonialSectionSchema: { [key: string]: IFormFieldType } = {
  testimonialSection: {
    type: 'Object',
    label: 'Testimonial Section',
    required: false,
    children: {
      heading: {
        type: 'String',
        label: 'Heading',
        required: false,
      },
      subHeading: {
        type: 'String',
        label: 'Sub Heading',
        required: false,
      },
      testimonials: {
        type: 'List',
        label: 'Testimonials',
        required: false,
        children: {
          title: {
            type: 'String',
            label: 'Name',
            required: false,
          },
          subTitle: {
            type: 'String',
            label: 'Sub Title',
            required: false,
          },
          testimonialURL: {
            type: 'String',
            label: 'Testimonial URL',
            required: false,
          },
          thumbnail: {
            type: 'Media',
            mediaTypes: [MediaType.IMAGE],
            label: 'Image',
            required: false,
          },
        },
      },
    },
  },
}

export default TestimonialSectionSchema

export type TestimonialProps = {
  title: string
  subTitle: string
  testimonialURL: string
  thumbnail: string
}

export type TestimonialSectionProps = {
  heading: string
  subHeading: string
  testimonials: TestimonialProps[]
  isMLP?: boolean
}

export type Testimonial = {
  testimonialSection: TestimonialSectionProps
}

export const TestimonialSectionDefaultValues: Testimonial = {
  testimonialSection: {
    heading: 'Stories of our Brighest Stars!',
    subHeading: 'Students and Parents ❤️ Curious Jr',
    testimonials: [
      {
        title: 'Improved my grades in school!',
        subTitle: 'Tejal, Class 8th',
        thumbnail:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/6e384f2b-c8f0-4d3c-88d6-a704ac15d2cc.webp',
        testimonialURL: 'https://www.youtube-nocookie.com/embed/fRp2B9k54l0?si=ZWV8hc-7PJ8rpGLw',
      },
      {
        title: 'Excelled in English, Maths and Science',
        subTitle: 'Arvind, Class 8th',
        thumbnail:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/344473c0-5a77-47f6-9ae4-206b1836ee6e.webp',
        testimonialURL: 'https://www.youtube-nocookie.com/embed/nUlFOYxbyCo?si=zEhyXtVuUbr11S4O',
      },
      {
        title: 'I love all my mentors : They help me with all my doubts',
        subTitle: 'Naksh, Class 3rd',
        thumbnail:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/f3a66aab-c4fa-4b03-b4a3-0b7ae330a350.webp',
        testimonialURL: 'https://www.youtube-nocookie.com/embed/xE4Ue7Vg0ss?si=fDPcEPRUgAAOBTNd',
      },
      {
        title: 'My Parents are happy. Thanks PW CJr!',
        subTitle: 'Utkarsh, Class 3rd',
        thumbnail:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/416d8181-3857-4660-bbfb-8e4a8902ff70.webp',
        testimonialURL: 'https://www.youtube-nocookie.com/embed/sxNxSMturUQ?si=QEbkFMiIszQW1t3i',
      },
    ],
  },
}
